import { EpimsBaseEntityDto } from './epim-base.dto';
export class BatchDto extends EpimsBaseEntityDto {

    id: string;
    BatchName: string;
    SubscriptionUserId: string;
    SubscriberId: string;
    dateCreated: Date;
    dateUpdated?: Date;
    CreatedById: string;
    ModifiedById: string;
    SiteId: string;
    Version: number;
}